<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New Category</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                id="name"
                v-model="name"
                label="Name"
                class="mb-0"
                type="text"
                required
                horizontal
                placeholder="Name"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                v-model="status"
                label="Status"
                :options="optionsStatus"
                required
                horizontal
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                :disabled="isSubmitting"
                @click="createCategory"
              >Save</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";

export default {
  name: "CorporateCategoryCreate",
  data() {
    return {
      name: "",
      status: "ACTIVE",
      isSubmitting: false,
      optionsStatus: ["ACTIVE", "INACTIVE"],
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
  },
  methods: {
    authentication() {
      const token = localStorage.getItem("token");
      const data = token ? jwt.decode(token) : null;
      const allowedGroups = ["MARKETING", "ADMIN", "ADMINISTRATOR"];

      if (data && allowedGroups.includes(data.account_group)) {
        return true;
      }

      this.$router.push({ path: "/" });
      return false;
    },
    goBack() {
      this.$router.push({ path: "/management/corporate-category" });
    },
    createCategory() {
      if (this.isSubmitting) {
        return;
      }

      if (!this.name.trim()) {
        Swal.fire({
          text: "Category harap diisi",
          showCloseButton: true,
          confirmButtonText: "OK",
        });
        return;
      }

      this.isSubmitting = true;
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("status", this.status);

      axios
        .post(`${this.domain}/v1/corporate_action_category`, formData, {
          headers: {
            Authorization: this.token,
          },
        })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Category Data Created",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.goBack();
          });
        })
        .catch((error) => {
          this.isSubmitting = false;
          const message =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message &&
            error.response.data.message.id;

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: message || "Terjadi kesalahan saat menyimpan kategori.",
          });
        });
    },
  },
};
</script>
